export default "<app-change-password (success)=\"onSuccess()\"></app-change-password>\n"